import React from 'react';
import ReactDOM from 'react-dom';
import Search from './Search';

if ($('body').hasClass('search-results')) {
  ReactDOM.render(<Search />, document.getElementById('search-results'));
}



// WEBPACK FOOTER //
// ./src/js/search-results.js